import { FilterKindEnum } from '../../../../../domains/global-filters/model/FilterChain';
import type { RadioTextFilterValueType } from '../../GenericBloc/GenericRadioTextFilter/GenericRadioTextType';
import { RadioTextFilterOperation } from '../../GenericBloc/GenericRadioTextFilter/GenericRadioTextType';
import type { AbstractSingleFilterPillsProps } from '../../SingleFilterType';
import { BaseURLFilter } from '../BaseURLFilter';

const optionalPlaceholders = {
  [RadioTextFilterOperation.CONTAINS]: 'e.g. login',
  [RadioTextFilterOperation.NOT_CONTAINS]: 'e.g. login',
};

interface VisitedURLFilterParmas extends AbstractSingleFilterPillsProps<RadioTextFilterValueType> {
  isFunnelStep?: boolean;
}

export function VisitedURLFilter({
  currentValue,
  autoFocus,
  onApply,
  onRemove,
  onDropdownHidden,
  showDropdownOnMount,
  isFunnelStep,
}: VisitedURLFilterParmas): JSX.Element {
  return (
    <BaseURLFilter
      filterKind={FilterKindEnum.VisitedURL}
      autoFocus={autoFocus}
      currentValue={currentValue}
      onApply={onApply}
      onRemove={onRemove}
      onDropdownHidden={onDropdownHidden}
      showDropdownOnMount={showDropdownOnMount}
      optionalPlaceholders={optionalPlaceholders}
      header="Sessions with users who viewed a page."
      isFunnelStep={isFunnelStep}
    />
  );
}
